import { z } from 'zod'

export const kakaoUserInfoSuccessResponseSchema = z.object({
  id: z.number(),
  has_signed_up: z.boolean().optional(),
  connected_at: z.string().optional(),
  synched_at: z.string().optional(),

  properties: z
    .object({
      nickname: z.string(),
      profile_image: z.string(),
      thumbnail_image: z.string(),
    })
    .optional(),

  kakao_account: z
    .object({
      profile_nickname_needs_agreement: z.boolean().optional(),
      profile_image_needs_agreement: z.boolean().optional(),
      profile: z
        .object({
          nickname: z.string().optional(),
          thumbnail_image_url: z.string().optional(),
          profile_image_url: z.string().optional(),
          is_default_image: z.boolean().optional(),
          is_default_nickname: z.boolean().optional(),
        })
        .optional(),
      name_needs_agreement: z.boolean().optional(),
      name: z.string().optional(),
      has_email: z.boolean().optional(),
      email_needs_agreement: z.boolean().optional(),
      is_email_valid: z.boolean().optional(),
      is_email_verified: z.boolean().optional(),
      email: z.string().optional(),
      has_phone_number: z.boolean().optional(),
      phone_number_needs_agreement: z.boolean().optional(),
      phone_number: z.string().optional(),
      has_age_range: z.boolean().optional(),
      age_range_needs_agreement: z.boolean().optional(),
      age_range: z.string().optional(),
      has_birthyear: z.boolean().optional(),
      birthyear_needs_agreement: z.boolean().optional(),
      birthyear: z.string().optional(),
      has_birthday: z.boolean().optional(),
      birthday_needs_agreement: z.boolean().optional(),
      birthday: z.string().optional(),
      birthday_type: z.string().optional(),
      is_leap_month: z.boolean().optional(),
      has_gender: z.boolean().optional(),
      gender_needs_agreement: z.boolean().optional(),
      gender: z.string().optional(),
    })
    .optional(),
})

export type KakaoUserInfoSuccessResponse = z.infer<typeof kakaoUserInfoSuccessResponseSchema>
